import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44aa26a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "thickness-selector" }
const _hoisted_2 = { class: "thickness-selector__options" }
const _hoisted_3 = ["href", "aria-label"]
const _hoisted_4 = ["aria-label"]

import { computed } from "vue";
import { useStore } from "vuex";
import sortBy from "lodash/sortBy";
import isEmpty from "lodash/isEmpty";
import TextLabel from "@/components/UI/TextLabel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ThicknessSelector',
  setup(__props) {

const store = useStore();
const i18n = window.measurementSelectorVariables.i18n;

const currentThickness = computed(() => store.getters.currentProductThickness);
const thicknesses = computed(() => sortBy( [ currentThickness.value, ...store.getters.alternateThicknesses ], [ 'thickness' ] ) );
const baseShapeInstanceModel = computed(() => store.getters.baseShapeInstance.model);

function isActive( thickness: number ): boolean {
	return currentThickness.value.thickness === thickness;
}
function getUrl( item: { thickness: number; permalink: string; } ): string {
	if ( isActive( item.thickness ) ) {
		return '#';
	}

	return item.permalink;
}
const generateTemporaryLink = async ( $event: { target: { href: string; }; } ): Promise<string> => {
	if ( ! isEmpty( baseShapeInstanceModel.value ) ) {
		location.href = await store.dispatch( 'generateShareableLink', { url: $event.target.href, isTemporary: true } );

		return;
	}

	location.href = $event.target.href;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TextLabel, { class: "subtitle" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(i18n).thickness_in_mm), 1)
      ]),
      _: 1
    }),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(thicknesses.value, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass({
				'thickness-selector__item': true,
				'thickness-selector__item--active': isActive( item.thickness ),
			}),
          key: index
        }, [
          (!isActive( item.thickness ))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _withModifiers(generateTemporaryLink, ["prevent"]),
                href: getUrl( item ),
                class: "thickness-selector__button",
                "aria-label": `${item.thickness}mm`
              }, _toDisplayString(item.thickness), 9, _hoisted_3))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: "#",
                class: "thickness-selector__button thickness-selector__button--active",
                "aria-label": `${item.thickness}mm`
              }, _toDisplayString(item.thickness), 9, _hoisted_4))
        ], 2))
      }), 128))
    ])
  ]))
}
}

})